// extracted by mini-css-extract-plugin
export default {"article":"product_article__umVIC","layout1":"product_layout1__Fnu8-","price":"product_price__h2dEO"};